import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

// Kept in the accessibility tree but takes no room and paints nothing.
const VISUALLY_HIDDEN_SX = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: '1px',
} as const;

type RepertoireReadoutLabelProps = {
  text: string;
  compact: boolean;
  sx: SxProps<Theme>;
};

// The ACCURACY / LISTEN label in the repertoire header's readout. MUS-607: a
// compact header (a short window) has no room to show it, but a screen reader
// still needs it, or the readout is read as a bare "--" or "87.5%". There it
// stays in the page, visually hidden, so the readout looks as before.
const RepertoireReadoutLabel = ({ text, compact, sx }: RepertoireReadoutLabelProps) =>
  compact ? (
    <Box component="span" sx={VISUALLY_HIDDEN_SX} data-rep-readout-label="">
      {text}
    </Box>
  ) : (
    <Box sx={sx} data-rep-readout-label="">
      {text}
    </Box>
  );

export default RepertoireReadoutLabel;
